<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <div class="tit">批发物流&发货信息参数</div>
      <div class="block">
        <h1><span class="mark">*</span>批发物流规则设置</h1>
        <div class="radio_box">
          <van-radio-group
            direction="horizontal"
            v-model="formData.runtype"
            @input="handleInputRuleType"
          >
            <van-radio name="1">统一按标准收取</van-radio>
            <van-radio
              name="2"
              :disabled="formData.orderrule == 2 || formData.specialarea == 2"
              >免物流费用</van-radio
            >
            <van-radio name="3">部分地区免物流费用</van-radio>
            <van-radio
              name="4"
              :disabled="formData.orderrule == 2 || formData.specialarea == 2"
              >到付</van-radio
            >
          </van-radio-group>
        </div>
        <div
          class="check_box"
          style="margin-top: 15px"
          v-if="formData.runtype == 3"
        >
          <p style="font-size: 12px; margin-bottom: 5px">
            <span class="mark" style="font-size: 12px">*</span
            >免物流费的特殊地区
          </p>
          <van-checkbox-group
            v-model="ruleCheck"
            direction="horizontal"
            @change="changeLabel"
          >
            <van-checkbox
              v-for="item in cityList"
              :name="item.areaid"
              :key="item.areaid"
              :disabled="isDisabled(item)"
              >{{ item.areaname }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>
      <div class="block">
        <h1><span class="mark">*</span>特殊订单规则设置</h1>
        <div class="radio_box">
          <van-radio-group v-model="formData.orderrule">
            <van-radio name="1">无特殊规则</van-radio>
            <van-radio
              name="2"
              :disabled="formData.runtype == 2 || formData.runtype == 4"
              >按照商品数量免物流费</van-radio
            >
          </van-radio-group>
        </div>
        <div
          class="input_box_wrap"
          style="margin-top: 15px"
          v-if="formData.orderrule == 2"
        >
          <p style="font-size: 12px; margin-bottom: 10px">
            <span class="mark" style="font-size: 12px">*</span>超过[]件商品
            免物流费（/件）
          </p>
          <div class="input_box">
            <van-field
              v-model="formData.goodsfullnum"
              type="digit"
              placeholder="请输入数量"
            />
          </div>
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>特殊地区规则设置</h1>
        <div class="radio_box">
          <van-radio-group v-model="formData.specialarea">
            <van-radio name="1">无特殊地区</van-radio>
            <van-radio
              name="2"
              :disabled="formData.runtype == 2 || formData.runtype == 4"
              >特殊地区物流费用增加[]%</van-radio
            >
          </van-radio-group>
        </div>
        <template v-if="formData.specialarea == 2">
          <div class="input_box_wrap" style="margin-top: 15px">
            <p style="font-size: 12px; margin-bottom: 10px">
              <span class="mark" style="font-size: 12px">*</span
              >特殊地区费用增加百分比（% 填写一个1=100的数字）
            </p>
            <div class="input_box">
              <van-field
                v-model="formData.pernum"
                type="digit"
                placeholder="请填写特殊地区费用增加百分比"
                min="1"
                max="100"
              />
            </div>
          </div>
          <div
            class="check_box"
            style="margin-top: 15px"
            v-if="formData.specialarea == 2"
          >
            <p style="font-size: 12px; margin-bottom: 5px">
              <span class="mark" style="font-size: 12px">*</span>特殊地区
            </p>
            <van-checkbox-group
              v-model="pernumCheck"
              direction="horizontal"
              @change="changeLabel1"
            >
              <van-checkbox
                v-for="item in cityList"
                :name="item.areaid"
                :key="item.areaid"
                :disabled="isDisabled1(item)"
                >{{ item.areaname }}</van-checkbox
              >
            </van-checkbox-group>
          </div>
        </template>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import { getProvince, encryptstringview } from "../../../api/api";
import {
  addShopPfLogistics,
  editShopPfLogistics,
  getShopPfLogisticsList,
} from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "addRulePf",
  data() {
    return {
      loading: false,
      cityList: [],
      ruleCheck: [], // 免物流特殊地区
      pernumCheck: [], //  特殊地区费用
      formData: {
        id: "",
        qyguid: "",
        cmid: "",
        runtype: "", // 物流规则设置
        province: "", // 免物流的特殊地区
        orderrule: "", // 特殊订单规则设置
        goodsfullnum: 0, // 超过[]件商品，免费物流
        specialarea: "", // 特殊地区规则设置
        pernum: 0, // 特殊地区费用增加百分比
        specialprovince: "", // 特殊地区
      },
    };
  },
  computed: {
    isDisabled() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.pernumCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    isDisabled1() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.ruleCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getProvince();
        this.getShopPfLogisticsList();
      } else {
        this.$router.back();
      }
    },

    // 获取物流信息
    getShopPfLogisticsList() {
      let qyguid = this.formData.qyguid;
      let params = {
        cmid: this.formData.cmid,
        pageindex: 1,
        pagesize: 100,
      };
      getShopPfLogisticsList(params).then((res) => {
        if (res.list.length > 0) {
          res.list.forEach((v) => {
            if (v.qyguid == qyguid) {
              this.formData.id = v.id ? v.id : "";
              this.formData.runtype = v.runtype ? v.runtype : "";
              this.formData.province = v.province ? v.province : "";
              let stringProvince = v.province ? v.province.split(",") : [];
              this.ruleCheck = stringProvince.map((str) => parseInt(str));
              this.formData.orderrule = v.orderrule ? v.orderrule : "";
              this.formData.goodsfullnum = v.goodsfullnum ? v.goodsfullnum : 0;
              this.formData.specialarea = v.specialarea ? v.specialarea : "";
              this.formData.pernum = v.pernum ? v.pernum : 0;
              this.formData.specialprovince = v.specialprovince
                ? v.specialprovince
                : "";
              let stringSpecialprovince = v.specialprovince
                ? v.specialprovince.split(",")
                : [];
              this.pernumCheck = stringSpecialprovince.map((str) =>
                parseInt(str)
              );
            }
          });
        }
      });
    },
    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.cityList = res;
      });
    },
    // 免物流特殊地区
    changeLabel() {
      this.formData.province = this.ruleCheck.join(",");
    },
    // 免物流特殊地区
    changeLabel1() {
      this.formData.specialprovince = this.pernumCheck.join(",");
    },
    // 单选-物流类型
    handleInputRuleType(e) {
      if (e == 2) {
        this.ruleCheck = [];
        this.pernumCheck = [];
        if (this.formData.orderrule == 2) {
          this.formData.orderrule = "";
          this.formData.goodsfullnum = "";
        }
        if (this.formData.specialarea == 2) {
          this.formData.specialarea = "";
          this.formData.pernum = "";
          this.formData.specialprovince = "";
        }
      }
    },

    query() {
      let { formData } = this;
      if (formData.intro == "") {
        this.$toast("请输入商品简介");
        return;
      }
      if (formData.runtype == "") {
        this.$toast("请选择物流规则设置");
        return;
      }
      if (formData.orderrule == "") {
        this.$toast("请选择特殊订单规则设置");
        return;
      }
      if (formData.specialarea == "") {
        this.$toast("请选择特殊地区规则设置");
        return;
      }
      if (formData.runtype == 3 && formData.province == "") {
        this.$toast("请选择免物流费的特殊地区");
        return;
      }
      if (formData.orderrule == 2 && formData.goodsfullnum == "") {
        this.$toast("请填写商品件数");
        return;
      }
      if (formData.specialarea == 2 && formData.pernum == "") {
        this.$toast("请填写特殊地区费用增加百分比");
        return;
      }
      if (formData.specialarea == 2 && formData.specialprovince == "") {
        this.$toast("请选择特殊地区");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (formData.id != "") {
        editShopPfLogistics(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            setTimeout(() => {
              history.back();
            }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopPfLogistics(formData).then((res) => {
          let data = res;
          if (data.result) {
            // setTimeout(() => {
            //   Toast.clear();
            //   this.$toast.success(data.message);
            // }, 500);
            setTimeout(() => {
              Toast.clear();
              history.back();
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .textarea_box {
        .van-cell {
          padding: 10px 0;
          width: 100%;
          height: 100%;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .van-radio,
  .van-checkbox {
    margin-bottom: 10px;
  }
}
</style>